import { Button, Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './errorPages.module.css';

const styles = {
  icon: {
    fontSize: '75px',
  },
  button: {
    marginTop: '2rem',
  },
};

const RootErrorFallback = () => (
  <div className={classes.page}>
    <div className={classes.contentContainer}>
      <div className={classes.content}>
        <Icon style={styles.icon} color={colors.neutral.silver}>
          error
        </Icon>
        <div className={classes.title}>Unknown Error</div>
        <div className={classes.subtext}>You've encountered an issue.</div>
        <div className={classes.subtext}>
          Please go to the homepage or contact support.
        </div>
        <a href="/" style={styles.button}>
          <Button variant="contained" color="primary">
            Go To Homepage
          </Button>
        </a>
      </div>
    </div>
  </div>
);

export default RootErrorFallback;
